import { render, staticRenderFns } from "./PromoBannerNew.vue?vue&type=template&id=804e9702&"
import script from "./PromoBannerNew.vue?vue&type=script&lang=js&"
export * from "./PromoBannerNew.vue?vue&type=script&lang=js&"
import style0 from "./PromoBannerNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports